
import firebase from 'firebase'

export default {
  data () {
    return {
      isValidDue: false,
      isLicReady: false,
      triggeredCap: 0,
      scheduledCap: 0,
      movieCap: 0
    }
  },

  filters: {
    convInterval: function (interval, currency) {
      const monthJp = 'ヶ月'
      const yearJp = '年間'

      if (currency === 'jpy') {
        if (interval === 'month') {
          return monthJp
        } else if (interval === 'year') {
          return yearJp
        }
      }
    },
    filterLicenseType: function (type) {
      if (type === 'free') {
        return '無料'
      } else if (type === 'basic') {
        return 'ベーシック'
      } else if (type === 'premium') {
        return 'プレミアム'
      }
      return 'エラー：判別不明のライセンス'
    },
    filterLicenseStatus: function (status) {
      if (status === 'free') {
        return '未契約'
      } else if (status === 'active') {
        return '有効'
      } else if (status === 'canceled') {
        return '自動継続がキャンセルされています！'
      }
      return 'エラー：ライセンスステータスが不明'
    },
    filterLicenseRecursive: function (recursive) {
      if (recursive === false) {
        return '自動継続'
      } else {
        return '自動継続がキャンセルされています！'
      }
    },
    filterLicenseExpiration: function (expiredAt) {
      var d = new Date(expiredAt * 1000)
      var y = new Date(expiredAt * 1000)
      var year = y.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var today = new Date()
      var thisYear = today.getFullYear()
      let ts = today.getTime()
      let todayTs = Math.floor(ts / 1000)

      if (expiredAt > todayTs) {
        if (year === thisYear) {
          return (month + '月' + day + '日 まで')
        } else {
          return (year + '年' + month + '月' + day + '日 まで')
        }
      } else {
        return (year + '年' + month + '月' + day + '日 に有効期限切れ')
      }
    }
  },

  methods: {
    getLicense: function () {
      const self = this
      const db = firebase.firestore()
      const licRef = db.collection('/license').doc(this.account.uid)

      return new Promise(async (resolve, reject) => {
        licRef.get()
          .then(function (doc) {
            if (doc.exists) {
              let val = doc.data()
              self.$store.commit('lic/set', val)
              self.isLicReady = true
              resolve(true)
            }
            resolve(false)
          }).catch(function (error) {
            console.log('Error GET License:', error)
            self.$ons.notification.alert('Licenseエラー<br>' + error)
            reject(error)
          })
      })
    },

    getCaps () {
      if (this.lic.role === 'free') {
        this.triggeredCap = 2
        this.scheduledCap = 2
        this.movieCap = 0
      } else if (this.lic.role === 'basic') {
        this.triggeredCap = 10
        this.scheduledCap = 10
        this.movieCap = 0
      } else {
        this.triggeredCap = 30
        this.scheduledCap = 30
        this.movieCap = 3
      }
    },

    checkLicense: async function (serviceType) {
      const freeMaxTriggeredNum = 2
      const freeMaxScheduledNum = 2
      const basicMaxTriggeredNum = 10
      const basicMaxScheduledNum = 10
      const premiumMaxTriggeredNum = 30
      const premiumMaxScheduledNum = 30
      const now = this.timestamp()

      const self = this
      const db = firebase.firestore()
      const licRef = db.collection('/license').doc(this.account.uid)

      return new Promise(async (resolve, reject) => {
        licRef.get()
        .then(function (doc) {
          if (doc.exists) {
            let val = doc.data()
            self.$store.commit('lic/set', val)
            // 有効期間チェック, プラン共通
            const dueDate = self.lic.expiredAt
            if (now > dueDate) {
              self.$ons.notification.alert('有効期間が終了しています！<br>メッセージの作成、編集を行うには<br>ライセンスを購入してください。')
              resolve(false)
            }
            // 有効期間内の場合, メッセージ数のチェック
            if (self.lic.role === 'free') {
              if (serviceType === 'scheduled') {
                if (self.lic.scheduled >= freeMaxScheduledNum) {
                  self.$ons.notification.alert('無料プランで作成可能な<br>送信日指定メッセージ数は<br>' + freeMaxScheduledNum + ' までです。')
                  resolve(false)
                }
              } else {
                if (self.lic.triggered >= freeMaxTriggeredNum) {
                  self.$ons.notification.alert('無料プランで作成可能な<br>トリガーメッセージ数は<br>' + freeMaxTriggeredNum + ' までです。')
                  resolve(false)
                }
              }
            } else if (self.lic.role === 'basic') {
              if (serviceType === 'scheduled') {
                if (self.lic.scheduled >= basicMaxScheduledNum) {
                  self.$ons.notification.alert('ベーシックプランで作成可能な<br>送信日指定メッセージ数は<br>' + basicMaxScheduledNum + ' までです。')
                  resolve(false)
                }
              } else {
                if (self.lic.triggered >= basicMaxTriggeredNum) {
                  self.$ons.notification.alert('ベーシックプランで作成可能な<br>トリガーメッセージ数は<br>' + basicMaxTriggeredNum + ' までです。')
                  resolve(false)
                }
              }
            } else if (self.lic.role === 'premium') {
              if (serviceType === 'scheduled') {
                if (self.lic.scheduled >= premiumMaxScheduledNum) {
                  self.$ons.notification.alert('プレミアムプランで作成可能な<br>送信日指定メッセージ数は<br>' + premiumMaxScheduledNum + ' までです。')
                  resolve(false)
                }
              } else {
                if (self.lic.triggered >= premiumMaxTriggeredNum) {
                  self.$ons.notification.alert('プレミアムプランで作成可能な<br>トリガーメッセージ数は<br>' + premiumMaxTriggeredNum + ' までです。')
                  resolve(false)
                }
              }
            }
            resolve(true)
          }
          resolve(false)
        }).catch(function (error) {
          console.log('Error GET License:', error)
          self.$ons.notification.alert('Licenseエラー<br>' + error)
          reject(error)
        })
      })
    },

    checkLicenseDue: async function () {
      const now = this.timestamp()
      const self = this
      const db = firebase.firestore()
      const licRef = db.collection('/license').doc(this.account.uid)

      return new Promise(async (resolve, reject) => {
        licRef.get()
        .then(function (doc) {
          if (doc.exists) {
            let val = doc.data()
            self.$store.commit('lic/set', val)
            const dueDate = self.lic.expiredAt
            if (now > dueDate) {
              // self.$ons.notification.alert('無料プランのご利用期間 ' + expireDays + '日間が終了しました。<br>継続利用には有料ライセンスの購入が必要です。')
              // self.$ons.notification.alert('無料プランのご利用期間<br>' + expireDays + '日間が終了しました。<br>メッセージの作成<br>編集は行えません。')
              resolve(false)
            }
            resolve(true)
          }
          resolve(false)
        }).catch(function (error) {
          console.log('Error GET License:', error)
          self.$ons.notification.alert('Licenseエラー<br>' + error)
          reject(error)
        })
      })
    },

    checkExpiration (lic) {
      const now = this.timestamp()
      const dueDate = lic.expiredAt
      if (now > dueDate) {
        this.isValidDue = false
      } else {
        this.isValidDue = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/com_license.js